






























































import { Component, Ref, Vue } from 'vue-property-decorator';
import PermissionService from '@/utils/permission-service';
import WebstoreApiTokenNewButton from '@/components/WebstoreApiToken/WebstoreApiTokenNewButton.vue';
import formatDateTime from '@/filters/formatDateTime';
import WebstoreApiTokenDeleteButton from './WebstoreApiTokenDeleteButton.vue';
import SApolloTable from '../UI/Table/SApolloTable.vue';
import { GQL_webstoreApiTokenList_currentUnit_webstoreApiTokens } from '@/queries/__generated__/webstoreApiTokenList';
import gql from 'graphql-tag';

const WEBSTORE_API_TOKEN_LIST = gql`
  query webstoreApiTokenList {
    currentUnit {
      id
      webstoreApiTokens {
        id
        expiryDate
        description
        createdBy {
          id
          name
        }
      }
    }
  }
`;

@Component({
  components: {
    WebstoreApiTokenNewButton,
    WebstoreApiTokenDeleteButton,
  },
})
export default class WebstoreApiTokenList extends Vue {
  private WEBSTORE_API_TOKEN_LIST = WEBSTORE_API_TOKEN_LIST;
  private PermissionService = PermissionService;
  private formatDateTime = formatDateTime;
  private showDialog = false;
  private tokenValue: string | null = null;

  @Ref() private table?: SApolloTable<GQL_webstoreApiTokenList_currentUnit_webstoreApiTokens>;

  private resetTableResult() {
    this.table?.refetch();
  }

  private openWarning(tokenValue: string | null) {
    this.showDialog = true;
    this.tokenValue = tokenValue;
  }
}
